import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import {
  getUsuariosMarketing,
  descargarMarketingExcel,
} from "../../../services/backend/usuarioService";
import { ensureCatalogAuth } from "../../../services/backend/authService";
import AppToast from "../../../shared/components/AppToast";
import { useRef } from "react";
import useAdminFetch from "../hooks/useAdminFetch";

const normalizeUsuarios = (response) =>
  Array.isArray(response?.usuarios) ? response.usuarios : [];

const Reportes = () => {
  const { rows, loading } = useAdminFetch(getUsuariosMarketing, {
    transform: normalizeUsuarios,
  });
  const [downloading, setDownloading] = useState(false);
  const toastRef = useRef(null);

  const handleDownloadExcel = async () => {
    if (downloading) return;
    setDownloading(true);
    try {
      await ensureCatalogAuth();
      const blob = await descargarMarketingExcel();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "usuarios-marketing.xls";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail:
          error?.message || "No fue posible descargar el reporte de marketing.",
        life: 4000,
      });
    } finally {
      setDownloading(false);
    }
  };

  const header = (
    <div className="flex align-items-center justify-content-between">
      <span className="text-xl font-semibold">
        Usuarios que aceptan marketing
      </span>
      <Button
        icon="pi pi-download"
        label="Descargar Excel"
        onClick={handleDownloadExcel}
        loading={downloading}
        severity="success"
      />
    </div>
  );

  return (
    <div className="py-3">
      <AppToast ref={toastRef} />
      <div className="grid">
        <div className="col-12">
          <h4 className="font-bold mb-1">Usuarios que aceptan marketing</h4>
          <p className="text-700 text-lg line-height-3 mb-3">
            Listado de usuarios con la preferencia de marketing activa.
          </p>
          <DataTable
            value={rows}
            header={header}
            showGridlines
            paginator
            rows={10}
            dataKey="id"
            stripedRows
            scrollable
            scrollHeight="calc(99vh - 370px)"
            rowsPerPageOptions={[5, 10, 25, 50]}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} usuarios"
            loading={loading}
            emptyMessage="No hay usuarios que acepten marketing."
          >
            <Column field="id" header="ID" style={{ width: "8%" }} />
            <Column field="nombre" header="Nombre" style={{ width: "24%" }} />
            <Column field="usuario" header="Usuario" style={{ width: "20%" }} />
            <Column field="email" header="Email" style={{ width: "28%" }} />
            <Column
              field="telefono"
              header="Teléfono"
              style={{ width: "15%" }}
            />
            <Column
              header="Perfil"
              style={{ width: "12%" }}
              body={(rowData) => rowData.perfil?.descripcion || ""}
            />
            <Column
              header="Marketing"
              style={{ width: "10%" }}
              body={(rowData) => (rowData.aceptaMarketing ? "Sí" : "No")}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default Reportes;
